export default function Carousel() {
  return {}
}
